/**
 * ARTESANO — Orden por stock en las páginas de colección.
 *
 * Reordena la grilla de productos de mayor a menor stock, dejando los agotados
 * al final. El dato de inventario lo publica sections/artesano-collection-order.liquid
 * como JSON, porque Shopify no expone el stock en el HTML de las tarjetas.
 *
 * No modifica ningún archivo del núcleo: no toca facets.js, card-product.liquid
 * ni main-collection-product-grid.liquid. Solo reordena nodos ya existentes.
 *
 * Respeta la elección del cliente: si hay `sort_by` en la URL, no hace nada.
 */

(function () {
  'use strict';

  const GRID = '#product-grid';
  const CONTAINER = '#ProductGridContainer';

  let stock = null;
  let defaultSort = '';
  let sorting = false;

  function readStock() {
    if (stock) return stock;
    const node = document.querySelector('script[data-artesano-stock]');
    if (!node) return null;
    defaultSort = node.dataset.defaultSort || '';
    try {
      stock = JSON.parse(node.textContent);
    } catch (error) {
      console.error('[artesano-collection-order] JSON de stock inválido', error);
      stock = null;
    }
    return stock;
  }

  /**
   * ¿El cliente eligió un orden distinto? Ojo: no alcanza con mirar si existe
   * `sort_by`. El formulario de filtros de Dawn lo incluye SIEMPRE, aunque el
   * cliente solo haya marcado un filtro, así que hay que comparar contra el
   * orden por defecto de la colección.
   */
  function customerChoseSort() {
    const chosen = new URLSearchParams(window.location.search).get('sort_by');
    if (!chosen) return false;
    return chosen !== defaultSort;
  }

  function handleOf(item) {
    const link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function sortGrid() {
    if (sorting) return;

    // readStock() primero: es quien completa `defaultSort`.
    const data = readStock();
    if (!data) return;
    if (customerChoseSort()) return;

    const grid = document.querySelector(GRID);
    if (!grid) return;

    const items = [...grid.querySelectorAll(':scope > .grid__item')];
    if (items.length < 2) return;

    // Los productos fuera del tope de 50 de Liquid quedan con 0: neutros,
    // por delante de los agotados y sin alterar su orden relativo.
    const scored = items.map((el, index) => {
      const handle = handleOf(el);
      const score = handle && handle in data ? data[handle] : 0;
      return { el, score, index };
    });

    // Orden estable: ante igual stock se conserva el orden original del tema.
    scored.sort((a, b) => b.score - a.score || a.index - b.index);

    const alreadySorted = scored.every((s, i) => s.index === i);
    if (alreadySorted) return;

    sorting = true;
    const fragment = document.createDocumentFragment();
    scored.forEach((s, i) => {
      // El tema escalona la animación de entrada con --animation-order;
      // hay que renumerarla o la cascada queda desordenada.
      if (s.el.style.getPropertyValue('--animation-order')) {
        s.el.style.setProperty('--animation-order', String(i + 1));
      }
      fragment.appendChild(s.el);
    });
    grid.appendChild(fragment);
    sorting = false;
  }

  /**
   * facets.js reemplaza el innerHTML de #ProductGridContainer al filtrar u
   * ordenar, y no publica ningún evento. Observamos ese contenedor —que sí
   * persiste— para volver a aplicar el orden.
   */
  function watch() {
    const container = document.querySelector(CONTAINER);
    if (!container) return;

    const observer = new MutationObserver(() => {
      if (sorting) return;
      sortGrid();
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    sortGrid();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
